import { JWPlayerVideos } from "@advice/apps/initJWPlayerVideos";
import { initHeader } from "@advice/apps/initHeader";
import { initEmailCapture } from "@advice/apps/initEmailCapture";
import { initJobsSidebar } from "@advice/apps/initJobsSidebar";
import { initLazyImages } from "@advice/apps/initLazyImages";
import { initOskarTriggers } from "@advice/apps/initOskarTriggers";
import { IInitialState } from "@server/util/pageWrapper";
import { ExperimentAB, IExperimentAB } from "@util/experiment";
import { isFeatureFlagActive } from "@util/featureFlags";
import { initGrowform } from "./apps/initGrowform";
import { initExperiment } from "./apps/initExperiment";
import { TOP_TEN_PAGES } from "./components/constants";

export interface AdviceWindow extends Window {
    __MUSE__: {
        initialState: IInitialState;
    };
    dataLayer: IMetadataObj[];
    experiment: IExperimentAB;
    ga: UniversalAnalytics.ga;
}

declare const window: AdviceWindow;

document.addEventListener("DOMContentLoaded", async () => {
    const initialState = window.__MUSE__.initialState;
    initLazyImages();
    window.experiment = new ExperimentAB(initialState?.config?.experiments);
    const excludeExperiment = TOP_TEN_PAGES.includes(initialState.slug);

    if (!excludeExperiment) {
        await initExperiment();
    }
    await initHeader(initialState);
    await initJobsSidebar();
    if (window.experiment.isAssignedExperiment("JOB_QUIZ_FORM") &&
        window.dataLayer[0].cms_post_type !== "landing" &&
        window.dataLayer[0].cms_post_type !== "companyLanding" &&
        window.dataLayer[0].cms_post_type !== "writer" &&
        !window.dataLayer[0].is_sponsored &&
        !excludeExperiment &&
        window.experiment.currentVariant.name !== "control"
    ) {
        await initGrowform();
    }
    await initOskarTriggers();
    await initEmailCapture(initialState);
    const jwPlayerID = ((initialState || {}).config || {}).jwPlayerID;
    if (jwPlayerID) {
        try {
            JWPlayerVideos.initJWPlayerVideos(jwPlayerID, initialState?.config, initialState?.templateName);
        } catch (error) {
            console.error("Could not initialize JWPlayer Videos: ", error);
        }
    }
});
